export default "__VITE_ASSET__Cc_0TlRr__"